import './App.css';
import Router from "./router/Router";

function App() {
    return <Router allRoutes={[]}/>;
}

export default App;
